// With the Tuning Results column defs were changed, we need to blow away that table's preferences
import PrefsService from "../services/PrefsService"

export default function migration4 () {
    PrefsService.delete('mui-user-table-column-sizes-radioConfigTuningHist')
    PrefsService.delete('mui-user-table-column-visibility-radioConfigTuningHist')
    PrefsService.delete('mui-user-table-column-order-radioConfigTuningHist')
}